export interface IDrugFormulation {
    id: string;
    drugDoses: { id: number; name: string }[],
    drugQuantities: { id: number; name: string }[]
}

export class DrugFormulation {
    id: string;
    drugDoses: { value: string; label: string }[];
    drugQuantities: { value: string; label: string }[];

    constructor(data: IDrugFormulation) {
        this.id = data.id;
        this.drugDoses = data.drugDoses.map(({id, name}) => ({
            value: id.toString(),
            label: name
        }));
        this.drugQuantities = data.drugQuantities.map(({id, name}) => ({
            value: id.toString(),
            label: name
        }));
    }
}

export interface IDrug {
    id: number;
    name: string,
    genericName: string
}

export interface IDrugs {
    drugs: { id: number; name: string, genericName: string }[];
    drugsCombobox: { value: string; label: string }[]
}

export class Drugs {
    drugs: { id: number; name: string, genericName: string }[];
    drugsCombobox: { value: string; label: string }[]

    constructor(data: IDrug[]) {
        this.drugs = data.map((drug: IDrug) => ({
            id: drug.id,
            name: drug.name,
            genericName: drug.genericName
        }));
        this.drugsCombobox = data.map((drug: IDrug) => ({
            value: drug.id.toString(),
            label: drug.name
        }));
    }
}